import heroImage from "@/assets/hero-dashboard.png";

const HeroImage = () => {
  return (
    <div className="max-w-[900px] mx-auto mt-16 mb-8 fade-on-scroll" style={{ animationDelay: '0.45s' }}>
      <div className="relative">
        <img
          src={heroImage}
          alt="AthleteNexus Dashboard Interface"
          className="w-full h-auto rounded-lg shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1)]"
        />
      </div>
    </div>
  );
};

export default HeroImage;
